import { UnitInput } from '../../atoms'
import { BasicFormItem, BasicFormItemProps } from './BasicFormItem'

export const FormUnit = ({
  unit,
  ...props
}: Omit<BasicFormItemProps, 'component'>) => (
  <BasicFormItem component={UnitInput} unit={unit} {...props} />
)
